module.exports = __webpack_public_path__ + "img/keder_beige_ohneral.5a50ecfa.jpg";